import { render, staticRenderFns } from "./PointCreditTechcoin.vue?vue&type=template&id=64bba728"
import script from "./PointCreditTechcoin.vue?vue&type=script&lang=js"
export * from "./PointCreditTechcoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports